import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { en } from '../i18n/en';
import { fr } from '../i18n/fr';
import { pt } from '../i18n/pt';
import axios from 'axios';

const translations = { en, fr, pt };
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('siq_lang') || 'en');

  const setLang = useCallback((code) => {
    setLangState(code);
    localStorage.setItem('siq_lang', code);
    // Persist to backend (fire-and-forget)
    const token = localStorage.getItem('token');
    if (token) {
      axios.post(`${API}/user/language`, { language: code }).catch(() => {});
    }
  }, []);

  // On mount, try to load user's saved language preference
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(`${API}/auth/me`).then(res => {
        const userLang = res.data?.language;
        if (userLang && translations[userLang]) {
          setLangState(userLang);
          localStorage.setItem('siq_lang', userLang);
        }
      }).catch(() => {});
    }
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations.en[key] || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
}
